import { $host } from './index';

export const getWebhooks = async () => {
  const { data } = await $host.get('web/webhooks/');
  return data;
};

export const getWebhook = async (id) => {
  const { data } = await $host.get(`web/webhooks/${id}`);
  return data;
};

export const getWebhookTypes = async () => {
  const { data } = await $host.get('web/webhooks/types');
  return data;
};

export const getWebhookEvents = async () => {
  const { data } = await $host.get('web/webhooks/events');
  return data;
};

export const getWebhookEvent = async (type) => {
  const { data } = await $host.get(`web/webhooks/events/${type}`);
  return data;
};

export const createWebhook = async (webhook) => {
  const { data } = await $host.post('web/webhooks/', webhook);
  return data;
};

export const updateWebhook = async (id, webhook) => {
  const { data } = await $host.put(`web/webhooks/${id}`, webhook);
  return data;
};

export const deleteWebhook = async (id) => {
  const { data } = await $host.delete(`web/webhooks/${id}`);
  return data;
};

export const testWebhook = async (id) => {
  const { data } = await $host.post(`web/webhooks/${id}/test`);
  return data;
};

export const getWebhookLogs = async (id, page = 0, size = 20) => {
  const { data } = await $host.get(`web/webhooks/${id}/logs`, {
    params: { page, size }
  });
  return data;
};
